// extracted by mini-css-extract-plugin
module.exports = {"imageBlockButton":"ImageBlock_imageBlockButton__PL6HT","imageBlock":"ImageBlock_imageBlock__DOibi","imageBlockCaption":"ImageBlock_imageBlockCaption__t8wbB"};